module.exports = __webpack_public_path__ + "static/media/  (15).18a21882.jpg";